import { useKeycloak } from '@react-keycloak/web';
import React, { FC, useCallback } from 'react';
import { Dialog } from 'shared/components/Dialog';
import { DialogName } from 'app/enums';
import { Box, Button, Typography } from '@mui/material';
import { modalsReducers } from 'app/store/modal/slice';
import { useDispatch } from 'react-redux';
import { useStyles } from './ActionGuardDialog.styles';

export const ActionGuardDialog: FC = () => {
  const { classes } = useStyles();
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();

  const baseButtonHandler = useCallback(() => {
    dispatch(modalsReducers.closeModal(DialogName.ActionGuard));
    window.history.pushState(window.history.state, document.title, document.location.href);
  }, [dispatch]);

  const onCloseHandler = useCallback(() => {
    baseButtonHandler();
    keycloak?.login();
  }, [keycloak, baseButtonHandler]);

  const acceptHandler = useCallback(() => {
    baseButtonHandler();
    keycloak?.register();
  }, [keycloak, baseButtonHandler]);

  return (
    <Dialog
      maxWidth="sm"
      contentHeight={120}
      name={DialogName.ActionGuard}
      actions={
        <>
          <Button
            fullWidth
            size="medium"
            color="primary"
            variant="outlined"
            className={classes.button}
            onClick={onCloseHandler}
          >
            Log In
          </Button>
          <Button
            fullWidth
            size="medium"
            color="primary"
            variant="contained"
            className={classes.button}
            onClick={acceptHandler}
          >
            Sign Up
          </Button>
        </>
      }
    >
      <Box className={classes.root}>
        <Typography className={classes.title}>Login or sign up</Typography>
      </Box>
    </Dialog>
  );
};
